/* eslint-disable eqeqeq */
import { Formik } from "formik";
import { useEffect, useState } from "react";
import Spin from "../../components/Spin";
import { CardTitle } from "../../components/ui/card";
import { Label } from "../../components/ui/label";
import CustomLabelText from "../../components/CustomLabelText";
import { Input } from "../../components/ui/input";
import { API, fileUpload, get } from "../../config";
import { PhoneInput } from "../../components/ui/phone-input";
import ReactInputMask from "react-input-mask";
import { cn } from "../../lib/utils";
import SearchSelect from "../../components/SearchSelect";
import { SuburbList, useBankList, useStateList } from "../../lib/OptionsAPI";
import { Loader2 } from "lucide-react";
import PostalCodeInput from "../../components/PostalCodeInput";
import { Checkbox } from "../../components/ui/checkbox";
import { NumericFormat } from "react-number-format";
import {
  formatBSBNumber,
  formatSubcontractorName,
  getModuleNamingBySlug,
  MaxLimit,
} from "../../lib/Misc";
import { Button } from "../../components/ui/button";
import VendorSelect from "../../components/VendorSelect";
import { useOrganization } from "../../lib/context/OrganisationContext";
import moment from "moment";
import { toast } from "../../components/ui/use-toast";
import { AddBeneficarySchema } from "../../lib/Validation";
import SuburbSelect from "../../components/SuburbSelect";
import TrustSelect from "../../components/TrustSelect";
import ContactSelect from "../../components/ContactSelect";
import { Step, Stepper } from "../../components/ui/stepper";
import VerificationStep from "../../components/Assessment_KYC/VerificationStep";
import AssessmentStep from "../../components/Assessment_KYC/AssessmentStep";
import { DateInputPicker } from "../../components/DateInputPicker";

const AddEditBeneficary = ({
  id,
  toggleShowAddEditBeneficary,
  edit,
  setEdit,
  fetchBeneficaryData,
  trustId,
  org = false,
  amlCTFEnable = false,
  onlyKyc = false,
}) => {
  const { organizationData } = useOrganization();

  let stepsData =
    edit && amlCTFEnable
      ? !onlyKyc
        ? [
            {
              label: `Beneficiary Details`,
            },
            {
              label: "Risk Assessment",
            },
            {
              label: "Verifications",
            },
          ]
        : [
            {
              label: "Risk Assessment",
            },
            {
              label: "Verifications",
            },
          ]
      : [
          {
            label: `Beneficiary Details`,
          },
        ];

  const [beneficaryId, setBeneficaryId] = useState(id ? id : "");
  const [beneficaryData, setBeneficaryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [suburbLoading, setSuburbLoading] = useState(false);
  const [suburbListing, setSuburbListing] = useState([]);
  const [suburbList, setSuburbList] = useState([]);
  const [suburbShippingLoading, setSuburbShippingLoading] = useState(false);
  const [suburbShippingListing, setSuburbShippingListing] = useState([]);
  const [suburbShippingList, setSuburbShippingList] = useState([]);

  const [trustLoading, setTrustLoading] = useState(false);
  const [trustListing, setTrustListing] = useState([]);
  const [trustList, setTrustList] = useState([]);

  const [vendorLoading, setVendorLoading] = useState(false);
  const [vendorListing, setVendorListing] = useState([]);
  const [vendorList, setVendorList] = useState([]);

  const [contactLoading, setContactLoading] = useState(false);
  const [contactListing, setContactListing] = useState([]);
  const [contactList, setContactList] = useState([]);

  const [sectionType, setSectionType] = useState(false);
  const [verificationMethods, setVerificationMethods] = useState([]);
  const [verificationTypes, setVerificationTypes] = useState([]);
  const [currentStep, setCurrentStep] = useState(0);

  const contactTypeOption = [
    {
      label: `${getModuleNamingBySlug(
        organizationData?.organizationData,
        "vendors",
        "Vendor",
      )}`,
      value: 1,
    },
    {
      label: `${getModuleNamingBySlug(
        organizationData?.organizationData,
        "contacts",
        "Customer",
      )}`,
      value: 2,
    },
  ];

  const toggleChecked = (values, setFieldValue) => {
    setIsChecked(!isChecked);
    if (isChecked === false) {
      setFieldValue("shipping_street", values?.street);
      setFieldValue("shipping_state_id", values?.state_id);
      setFieldValue("shipping_suburb_id", values?.suburb_id);
      setFieldValue("shipping_postal_code", values?.postal_code);
      setSuburbShippingListing([
        suburbListing?.find((item) => item.value === values?.suburb_id),
      ]);
    } else {
      setFieldValue("shipping_street", "");
      setFieldValue("shipping_state_id", "");
      setFieldValue("shipping_suburb_id", "");
      //   dispatch(shippingSuburbsList("", ""));
      setSuburbShippingListing([]);
      setSuburbShippingList([]);
      setFieldValue("shipping_postal_code", "");
    }
  };

  const FetchSuburbList = async (state_id) => {
    await SuburbList(state_id, 1, setSuburbLoading, setSuburbList, true);
  };

  useEffect(() => {
    if (suburbList) {
      let suburbTempListing = suburbList?.map((item) => ({
        ...item,
        value: item.id,
        label: item.name,
      }));
      setSuburbListing(suburbTempListing || []);
    } else {
      setSuburbListing([]);
    }
  }, [suburbList]);

  const FetchSuburbShippingList = async (state_id) => {
    await SuburbList(
      state_id,
      1,
      setSuburbShippingLoading,
      setSuburbShippingList,
      true,
    );
  };

  useEffect(() => {
    if (suburbShippingList) {
      let suburbShippingTempListing = suburbShippingList?.map((item) => ({
        ...item,
        value: item.id,
        label: item.name,
      }));
      setSuburbShippingListing(suburbShippingTempListing || []);
    } else {
      setSuburbShippingListing([]);
    }
  }, [suburbShippingList]);

  useEffect(() => {
    if (vendorList) {
      let vendorTempListing = vendorList?.map((item) => ({
        ...item,
        value: item?.id,
        label: `${formatSubcontractorName(item)}${
          item?.code ? ` (${item?.code})` : ""
        }`,
      }));
      setVendorListing(vendorTempListing || []);
    } else {
      setVendorListing([]);
    }
  }, [vendorList]);

  useEffect(() => {
    if (contactList) {
      let contactTempListing = contactList?.map((item) => ({
        ...item,
        value: item.id,
        label: `${formatSubcontractorName(item)}${
          item?.code ? ` (${item?.code})` : ""
        }`,
      }));
      setContactListing(contactTempListing || []);
    } else {
      setContactListing([]);
    }
  }, [contactList]);

  const fetchVerificationMethodsTypes = async () => {
    try {
      setLoading(true);
      const { data } = await get(`${API.VERFICATION_TYPES}`);
      setVerificationMethods(data?.verification_methods);
      setVerificationTypes(data?.document_types);
      setLoading(false);
    } catch (e) {
      setVerificationMethods([]);
      setVerificationTypes([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVerificationMethodsTypes();
  }, []);

  const normalizeVerificationData = (data = {}, verificationType = {}) => {
    if (!verificationType?.fields) return data;

    const dateKeys = verificationType.fields
      .filter((f) => f.inputType === "date")
      .map((f) => f.key);

    const normalizedData = { ...data };

    dateKeys.forEach((key) => {
      if (normalizedData[key]) {
        normalizedData[key] = moment(normalizedData[key], "DD-MM-YYYY");
      }
    });

    return normalizedData;
  };

  async function fetchData() {
    try {
      setLoading(true);
      const reponse = await get(`${API.BENEFICARY_DETAILS}/` + beneficaryId);

      let data = reponse?.data?.data;

      setSectionType(
        data?.kyc?.cdd_customer_type
          ? `Onboarding-${data?.kyc?.cdd_customer_type === "1" ? "Ongoing" : "Initial"}`
          : "",
      );
      if (data?.same_address) {
        setIsChecked(true);
      } else {
        setIsChecked(false);
      }
      if (data?.state_id ? data?.state_id : false) {
        FetchSuburbList(data?.state_id ? data?.state_id : "", "");
        if (data?.suburb_id ? data?.suburb_id : false) {
          setSuburbList([
            data?.suburb
              ? {
                  ...data?.suburb,
                  value: data?.suburb.id,
                  label: data?.suburb.name,
                }
              : {},
          ]);
        }
      }
      if (data?.shipping_state_id ? data?.shipping_state_id : false) {
        FetchSuburbShippingList(
          data?.shipping_state_id ? data?.shipping_state_id : "",
          "",
        );
        if (data?.shipping_suburb_id ? data?.shipping_suburb_id : false) {
          setSuburbShippingList([
            data?.shipping_suburb
              ? {
                  ...data?.shipping_suburb,
                  value: data?.shipping_suburb.id,
                  label: data?.shipping_suburb.name,
                }
              : {},
          ]);
        }
      }

      data?.kyc?.verifications?.length > 0 &&
        data.kyc.verifications?.map((item) => {
          item.mobile = data?.mobile
            ? data?.mobile[0] === "+"
              ? data?.mobile
              : `+${data?.mobile}`
            : "";
          item.verified_status = item.verified === 1 ? true : false;
          item.date_verified = item.date_verified
            ? moment(item.date_verified, "DD-MM-YYYY")
            : null;
          item.verified_by = item?.verified_by_id ? item?.verified_by_id : "";
          item.type = item?.verification_document_type_id
            ? item?.verification_document_type_id
            : "";
          item.dynamicFields = normalizeVerificationData(
            item?.data,
            item?.verification_document_type,
          );
          return item;
        });
      if (data?.type == "2" && data?.entity_type != "1") {
        stepsData = stepsData?.filter((item) => item.label !== "Verifications");
      }
      setCurrentStep(
        data?.current_step
          ? data?.current_step > stepsData?.length - 1
            ? 0
            : data?.current_step
          : 0,
      );

      setBeneficaryData(reponse?.data?.data);
      setLoading(false);
    } catch (e) {
      setBeneficaryData(null);
    }
  }
  useEffect(() => {
    if (edit) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [beneficaryId]);

  // State
  const { stateLoading, stateList = [] } = useStateList();
  const stateListing = stateList?.map((item) => {
    const { id: value, name, short_name, ...rest } = item;
    return { label: name + ` (${short_name})`, value, ...rest };
  });
  const state = stateListing?.find(
    (item) =>
      item?.value ===
      (beneficaryData?.state_id ? beneficaryData?.state_id : ""),
  )?.value;

  // ShippingState
  const shippingStateListing = stateList?.map((item) => {
    const { name: label, id: value, ...rest } = item;
    return { label, value, ...rest };
  });
  const shippingState = shippingStateListing?.find(
    (item) =>
      item?.value ===
      (beneficaryData?.shipping_state_id
        ? beneficaryData?.shipping_state_id
        : ""),
  )?.value;

  // Bank
  const { bankLoading, bankList = [] } = useBankList();
  const bankListing = bankList ? bankList : [];
  const projectBank = bankListing?.find(
    (item) => item?.value === beneficaryData?.bank_id,
  )?.value;

  useEffect(() => {
    if (trustList) {
      let trustTempListing = trustList?.map((item) => ({
        ...item,
        value: item.id,
        label: `${
          item?.business_name
            ? item?.business_name
            : item?.first_name
              ? item?.first_name + " " + item?.last_name
              : item?.last_name
        } ${item?.account_number ? `(${item?.account_number})` : ""}`,
      }));
      let finalList = trustTempListing?.filter(
        (item) => item?.id !== trustId && item?.id !== "new",
      );
      setTrustListing(finalList || []);
    } else {
      setTrustListing([]);
    }
  }, [trustList, trustId]);

  const handleFormSubmit = async (value, { setErrors, resetForm }) => {
    const formData = new FormData();

    value.phone = value?.phone ? `${value?.phone}`.replace(/ /g, "") : "";
    value.mobile = value?.mobile ? `${value?.mobile}`.replace(/ /g, "") : "";
    value.abn = value?.abn ? `${value?.abn}`.replace(/ /g, "") : "";

    formData.append(
      "organization_id",
      organizationData?.organizationId ? organizationData?.organizationId : "",
    );
    if (org && value?.trust_id ? value?.trust_id : trustId) {
      formData.append(
        "trust_id",
        org && value?.trust_id ? value?.trust_id : trustId ? trustId : "",
      );
    }

    formData.append(
      "contactable_id",
      value?.contactable_id ? value?.contactable_id : "",
    );
    formData.append("current_step", currentStep + 1);
    formData.append("vendor_id", value?.vendor_id ? value?.vendor_id : "");
    formData.append("first_name", value?.first_name ? value?.first_name : "");
    formData.append("last_name", value?.last_name ? value?.last_name : "");
    formData.append("phone", value?.phone ? value?.phone : "");
    formData.append("mobile", value?.mobile ? value?.mobile : "");
    formData.append("email", value?.email ? value?.email : "");
    formData.append(
      "business_name",
      value?.business_name ? value?.business_name : "",
    );
    formData.append("abn", value?.abn ? value?.abn : "");
    formData.append(
      "dob",
      value?.dob ? moment(value?.dob)?.format("DD-MM-YYYY") : "",
    );
    formData.append(
      "license_number",
      value?.license_number ? value?.license_number : "",
    );
    formData.append("code", value?.code ? value?.code : "");

    formData.append(
      "percentage",
      value?.percentage ? value?.percentage?.toString()?.replace("%", "") : "",
    );
    formData.append("street", value?.street ? value?.street : "");
    formData.append("state_id", value?.state_id ? value?.state_id : "");
    formData.append("suburb_id", value?.suburb_id ? value?.suburb_id : "");
    formData.append(
      "postal_code",
      value?.postal_code ? value?.postal_code : "",
    );
    formData.append("same_address", isChecked ? 1 : 0);
    formData.append(
      "shipping_street",
      value?.shipping_street ? value?.shipping_street : "",
    );
    formData.append(
      "shipping_state_id",
      value?.shipping_state_id ? value?.shipping_state_id : "",
    );
    formData.append(
      "shipping_suburb_id",
      value?.shipping_suburb_id ? value?.shipping_suburb_id : "",
    );
    formData.append(
      "shipping_postal_code",
      value?.shipping_postal_code ? value?.shipping_postal_code : "",
    );
    formData.append(
      "account_name",
      value?.account_name ? value?.account_name : "",
    );
    formData.append("bsb", value?.bsb ? formatBSBNumber(value?.bsb) : "");
    formData.append(
      "account_number",
      value?.account_number ? value?.account_number : "",
    );
    formData.append(
      "opening_balance",
      value?.opening_balance ? value?.opening_balance : 0,
    );
    formData.append("bank_id", value?.bank_id ? value?.bank_id : "");
    formData.append("type", value?.type ? value?.type : "");

    if (value.is_kyc) {
      formData.append("risk", value?.risk ? value?.risk : "");
      formData.append(
        "cdd_customer_type",
        value?.cdd_customer_type ? value?.cdd_customer_type : "",
      );

      formData.append("cdd", value?.cdd ? value?.cdd : "");
      formData.append("notes", value?.notes ? value?.notes : "");
      formData.append("ntf_note", value?.ntf_note ? value?.ntf_note : "");
      formData.append(
        "risk_assessment_id",
        value?.risk_assessment_id ? value?.risk_assessment_id : "",
      );

      formData.append(
        "compliance_manager_id",
        value?.compliance_manager_id ? value?.compliance_manager_id : "",
      );

      formData.append("reason", value?.reason ? value?.reason : "");

      if (value.verifications?.length) {
        value.verifications.forEach((row, index) => {
          // ▪ METHOD
          formData.append(`verifications[${index}][method]`, row.method ?? "");

          // ▪ METHOD = 1 OR 2 → FILE
          // if ((row.method === 1 || row.method === 2) && row.file) {
          //   formData.append(
          //     `verifications[${index}][file]`,
          //     row.file.file // AntD upload stores file under .file
          //   );
          // }

          // ▪ METHOD = 3 → TYPE
          if (row.id) {
            formData.append(`verifications[${index}][id]`, row.id ?? "");
          }

          formData.append(`verifications[${index}][type]`, row.type ?? "");

          formData.append(
            `verifications[${index}][date_verified]`,
            moment.isMoment(row.date_verified)
              ? row.date_verified.format("DD-MM-YYYY")
              : row.date_verified instanceof Date
                ? moment(row.date_verified).format("DD-MM-YYYY")
                : row.date_verified || "",
          );
          formData.append(
            `verifications[${index}][document_number]`,
            row.document_number ?? "",
          );

          formData.append(
            `verifications[${index}][verified_by]`,
            typeof row.verified_by === "object" && row.verified_by !== null
              ? row.verified_by.id || row.verified_by.verified_by_id || ""
              : row.verified_by || "",
          );
          formData.append(
            `verifications[${index}][verified]`,
            row.verified ?? "",
          );

          formData.append(
            `verifications[${index}][key]`,
            verificationTypes?.find((item) => item.id === row?.type)?.key &&
              row?.type
              ? verificationTypes?.find((item) => item.id === row?.type)?.key
              : "",
          );

          if (row.method === 3) {
            // ▪ Dynamic Fields
            if (row.dynamicFields) {
              Object.keys(row.dynamicFields).forEach((key) => {
                let value = row.dynamicFields[key];

                // If value is moment
                if (moment.isMoment(value)) {
                  value = value.format("DD-MM-YYYY");
                }

                // If value is JS Date
                else if (value instanceof Date) {
                  value = moment(value).format("DD-MM-YYYY");
                }

                formData.append(
                  `verifications[${index}][fields][${key}]`,
                  value ?? "",
                );
              });
            }
          }
        });
      }
    }

    if (edit) {
      formData.append("_method", "put");
    }
    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.BENEFICARY_ADD}${edit ? `/${beneficaryId}` : ""}`,
        formData,
      );
      if (!edit && data && amlCTFEnable) {
        setBeneficaryId(data?.data?.id);
        setEdit(true);
      }
      setLoading(false);
      // if (data) {
      //   toggleShowAddEditBeneficary();
      //   fetchBeneficaryData();
      // }
      setCurrentStep(Number(Number(currentStep) + 1));
      if (data?.data?.type == "2" && data?.data?.entity_type != "1") {
        stepsData = stepsData?.filter((item) => item.label !== "Verifications");
      }
      if (data) {
        org
          ? (edit || !setEdit) &&
            amlCTFEnable &&
            stepsData?.length - 1 === currentStep &&
            toggleShowAddEditBeneficary()
          : stepsData?.length - 1 === currentStep &&
            toggleShowAddEditBeneficary();
      }
      if (data?.data) {
        data?.data?.kyc?.verifications?.length > 0 &&
          data?.data.kyc.verifications?.map((item) => {
            item.mobile = data?.data?.mobile
              ? data?.data?.mobile[0] === "+"
                ? data?.data?.mobile
                : `+${data?.data?.mobile}`
              : "";
            item.verified_status = item.verified === 1 ? true : false;
            item.date_verified = item.date_verified
              ? moment(item.date_verified, "DD-MM-YYYY")
              : null;
            item.verified_by = item?.verified_by_id ? item?.verified_by_id : "";
            item.type = item?.verification_document_type_id
              ? item?.verification_document_type_id
              : "";
            item.dynamicFields = normalizeVerificationData(
              item?.data,
              item?.verification_document_type,
            );
            return item;
          });
        setBeneficaryData(data?.data);
      }
      return data?.data;
    } catch (error) {
      setLoading(false);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const handleDownload = async (export_report_path) => {
    try {
      if (export_report_path) {
        var a = document.createElement("a");
        a.href = export_report_path;
        var file = export_report_path.split("/");
        a.setAttribute("download", file[file.length - 1] || "file.pdf");
        a.setAttribute("target", "_blank");
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    } catch (e) {
      const errors = e.response?.data?.errors;
      toast({
        variant: "destructive",
        description: errors,
        duration: 3000,
      });
    }
  };

  return (
    <Formik
      initialValues={{
        trust_id: beneficaryData?.trust_id
          ? beneficaryData?.trust_id
          : trustId
            ? trustId
            : "",
        contactable_id: beneficaryData?.contactable_id
          ? beneficaryData?.contactable_id
          : "",
        contactable_type:
          beneficaryData?.contactable_type === "vendor"
            ? 1
            : beneficaryData?.contactable_type === "contact"
              ? 2
              : "",
        code: beneficaryData?.code,
        first_name: beneficaryData?.first_name,
        last_name: beneficaryData?.last_name,
        phone: beneficaryData?.phone,
        mobile: beneficaryData?.mobile,
        email: beneficaryData?.email,
        business_name: beneficaryData?.business_name,
        abn: beneficaryData?.abn,
        dob: beneficaryData?.dob
          ? moment(beneficaryData?.dob, "DD-MM-YYYY")
          : "",

        kyb_report_file: beneficaryData?.kyc?.kyb_report_file
          ? beneficaryData?.kyc?.kyb_report_file
          : "",

        license_number: beneficaryData?.license_number,

        street: beneficaryData?.street,
        state_id: state,
        suburb_id: beneficaryData?.suburb_id ? beneficaryData?.suburb_id : "",
        postal_code: beneficaryData?.postal_code
          ? beneficaryData?.postal_code.toString()
          : "",

        same_address: false,

        shipping_street: beneficaryData?.shipping_street,
        shipping_state_id: shippingState,
        shipping_suburb_id: beneficaryData?.shipping_suburb_id
          ? beneficaryData?.shipping_suburb_id
          : "",
        shipping_postal_code: beneficaryData?.shipping_postal_code
          ? beneficaryData?.shipping_postal_code.toString()
          : "",

        account_name: beneficaryData?.account_name
          ? beneficaryData?.account_name
          : "",
        bsb: beneficaryData?.bsb ? beneficaryData?.bsb : "",
        account_number: beneficaryData?.account_number
          ? beneficaryData?.account_number
          : "",
        bank_id: projectBank ? projectBank : "",
        opening_balance: beneficaryData?.opening_balance
          ? beneficaryData?.opening_balance
          : 0,
        photo_id: beneficaryData?.kyc?.photo_id
          ? beneficaryData?.kyc?.photo_id
          : "",
        primary_id: beneficaryData?.kyc?.primary_id
          ? beneficaryData?.kyc?.primary_id
          : null,
        secondary_id: beneficaryData?.kyc?.secondary_id
          ? beneficaryData?.kyc?.secondary_id
          : null,
        verification_date: beneficaryData?.kyc?.verification_date
          ? moment(beneficaryData?.kyc?.verification_date, "DD-MM-YYYY")
          : "",
        verified_by: beneficaryData?.kyc?.verified_by
          ? beneficaryData?.kyc?.verified_by
          : "",
        method: beneficaryData?.kyc?.method ? beneficaryData?.kyc?.method : "",
        risk: beneficaryData?.kyc?.risk ? beneficaryData?.kyc?.risk : "",
        cdd: beneficaryData?.kyc?.cdd ? beneficaryData?.kyc?.cdd : "",
        cdd_customer_type: beneficaryData?.kyc?.cdd_customer_type
          ? beneficaryData?.kyc?.cdd_customer_type
          : "",
        notes: beneficaryData?.kyc?.notes ? beneficaryData?.kyc?.notes : "",
        ntf_note: beneficaryData?.kyc?.ntf_note
          ? beneficaryData?.kyc?.ntf_note
          : "",
        percentage: beneficaryData?.percentage
          ? beneficaryData?.percentage
          : "0",
        type: beneficaryData?.type ? beneficaryData?.type : "1",
        is_kyc:
          amlCTFEnable && edit
            ? beneficaryData?.is_kyc || onlyKyc
              ? beneficaryData?.is_kyc == "1" || onlyKyc || currentStep === 1
                ? true
                : false
              : true
            : false,
        verifications: beneficaryData?.kyc?.verifications
          ? beneficaryData?.kyc?.verifications
          : [
              {
                method: "",
                type: "",
                document_number: "",
                date_verified: "",
                verified_by: "",
                verified: "",
                dynamicFields: {},
                mobile: beneficaryData?.mobile
                  ? beneficaryData?.mobile[0] === "+"
                    ? beneficaryData?.mobile
                    : `+${beneficaryData?.mobile}`
                  : "",
              },
            ],
        risk_assessment_id: beneficaryData?.kyc?.risk_assessment?.id
          ? beneficaryData?.kyc?.risk_assessment?.id
          : "",

        compliance_manager_id: beneficaryData?.kyc?.risk_profile_changes
          ?.compliance_manager_id
          ? beneficaryData?.kyc?.risk_profile_changes?.compliance_manager_id
          : "",
        compliance_manager_name: beneficaryData?.kyc?.risk_profile_changes
          ?.compliance_manager_name
          ? beneficaryData?.kyc?.risk_profile_changes?.compliance_manager_name
          : "",
        reason: beneficaryData?.kyc?.risk_profile_changes?.reason
          ? beneficaryData?.kyc?.risk_profile_changes?.reason
          : "",
      }}
      enableReinitialize={true}
      onSubmit={handleFormSubmit}
      validateOnBlur={true}
      validateOnChange={true}
      validationSchema={AddBeneficarySchema(organizationData, currentStep)}
    >
      {({
        values,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isValid,
        setTouched,
        validateField,
      }) => (
        <>
          {loading && <Spin expand={true} fullscreen={true} />}
          <form
            onSubmit={handleSubmit}
            noValidate
            className="entry-section md:m-0 m-5"
          >
            <div className="form-box overflow-y-auto overflow-x-hidden h-[80vh] p-4 border rounded-lg">
              <Stepper
                key={currentStep}
                initialStep={currentStep}
                steps={stepsData}
                // onClickStep={(step, setStep) => {
                //   edit && setStep(step);
                // }}
                className="justify-center mb-2"
              >
                {!onlyKyc && (
                  <Step
                    label={`Beneficiary Details`}
                    horizontalStepClassName={"flex flex-col gap-2 font-bold"}
                  >
                    <>
                      <div className="grid gap-4">
                        <CardTitle className="text-md">
                          Beneficiary Details
                        </CardTitle>
                        <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-4">
                          {/* <div className="grid md:grid-cols-2 gap-4"> */}
                          {org && (
                            <div className="grid gap-2">
                              <div className="min-w-0">
                                <Label htmlFor="trust_id">
                                  <CustomLabelText
                                    required={false}
                                    labelText="Trust"
                                    errorField={errors?.trust_id}
                                    bottomAlign={true}
                                  />
                                </Label>
                                <div className="relative mt-2">
                                  <TrustSelect
                                    orgId={organizationData?.organizationId}
                                    frameworkData={trustListing} // List of vendors
                                    optionType="Trust"
                                    handleBlur={handleBlur}
                                    handleSelect={(e) => {
                                      setFieldValue("trust_id", e);
                                      setFieldValue("contactable_id", "");
                                      setFieldValue("contactable_type", "");

                                      setVendorListing([]);
                                      setVendorList([]);

                                      setContactList([]);
                                      setContactListing([]);
                                    }}
                                    name="trust_id"
                                    disabled={
                                      organizationData?.organizationId
                                        ? false
                                        : true
                                    }
                                    initialValue={
                                      values?.trust_id ? values?.trust_id : ""
                                    }
                                    setTrustList={setTrustList} // Update vendor list as new data loads
                                    setTrustLoading={setTrustLoading} // Control loading state
                                    onClear={() => {
                                      setFieldValue("trust_id", "");
                                      setFieldValue("contactable_id", "");
                                      setFieldValue("contactable_type", "");

                                      setVendorListing([]);
                                      setVendorList([]);

                                      setContactList([]);
                                      setContactListing([]);
                                    }}
                                    loading={trustLoading}
                                  />
                                  {trustLoading && (
                                    <span className="absolute top-2 right-2 animate-spin">
                                      <Loader2 width={20} height={20} />
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                          <div className="grid gap-2">
                            <Label htmlFor="contactable_type">
                              <CustomLabelText
                                required={true}
                                labelText="Contact Type"
                                errorField={errors?.contactable_type}
                                bottomAlign={true}
                              />
                            </Label>
                            <div className="relative">
                              <SearchSelect
                                frameworks={contactTypeOption}
                                optionType={"Contact Type"}
                                handleSelect={(e) => {
                                  setFieldValue("contactable_type", e);
                                  setFieldValue("contactable_id", "");
                                  setTimeout(() => {
                                    setTouched({ contactable_type: true });
                                    validateField("contactable_type");
                                  }, 0);

                                  setTimeout(() => {
                                    setTouched({ contactable_id: true });
                                    validateField("contactable_id");
                                  }, 0);
                                }}
                                handleBlur={handleBlur}
                                className={
                                  errors?.base_type &&
                                  `focus-visible:ring-red-500 border-red-500`
                                }
                                disabled={false}
                                initialValue={values?.contactable_type}
                              />
                            </div>
                          </div>

                          {values?.contactable_type === 1 ? (
                            <div className="grid gap-2">
                              <div className="min-w-0">
                                <Label htmlFor="contactable_id">
                                  <CustomLabelText
                                    labelText={getModuleNamingBySlug(
                                      organizationData?.organizationData,
                                      "vendors",
                                      "Vendor",
                                    )}
                                    errorField={errors?.contactable_id}
                                    required={true}
                                  />
                                </Label>
                                <div className="relative mt-2">
                                  <VendorSelect
                                    organizationId={
                                      organizationData?.organizationId
                                        ? organizationData?.organizationId
                                        : ""
                                    }
                                    trustId={
                                      values?.trust_id ? values?.trust_id : ""
                                    }
                                    amlctfContact={
                                      values?.trust_id ? false : true
                                    }
                                    frameworkData={vendorListing} // List of vendors
                                    optionType={getModuleNamingBySlug(
                                      organizationData?.organizationData,
                                      "vendors",
                                      "Vendor",
                                    )}
                                    handleSelect={(e) => {
                                      setFieldValue("contactable_id", e);
                                    }}
                                    name="contactable_id"
                                    disabled={false}
                                    initialValue={
                                      values?.contactable_id
                                        ? values?.contactable_id
                                        : ""
                                    }
                                    setVendorList={setVendorList} // Update vendor list as new data loads
                                    setVendorLoading={setVendorLoading} // Control loading state
                                    onClear={() => {
                                      setFieldValue("contactable_id", "");
                                    }}
                                    loading={vendorLoading}
                                    className={
                                      errors?.contactable_id &&
                                      `focus-visible:ring-red-500 border-red-500`
                                    }
                                  />
                                  {vendorLoading && (
                                    <span className="absolute top-2 right-2 animate-spin">
                                      <Loader2 width={20} height={20} />
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          ) : values?.contactable_type === 2 ? (
                            <div className="grid gap-2">
                              <div className="min-w-0">
                                <Label htmlFor="contactable_id">
                                  <CustomLabelText
                                    labelText={`${getModuleNamingBySlug(
                                      organizationData?.organizationData,
                                      "contacts",
                                      "Customer",
                                    )}`}
                                    errorField={errors?.contactable_id}
                                    required={true}
                                  />
                                </Label>
                                <div className="relative mt-2">
                                  <ContactSelect
                                    organizationId={
                                      organizationData?.organizationId
                                        ? organizationData?.organizationId
                                        : ""
                                    }
                                    trustId={
                                      values?.trust_id ? values?.trust_id : ""
                                    }
                                    amlctfContact={
                                      values?.trust_id ? false : true
                                    }
                                    frameworkData={contactListing} // List of vendors
                                    optionType={`${getModuleNamingBySlug(
                                      organizationData?.organizationData,
                                      "contacts",
                                      "Customer",
                                    )}`}
                                    handleSelect={(e) => {
                                      setFieldValue(`contactable_id`, e);
                                    }}
                                    name="contactable_id"
                                    disabled={false}
                                    initialValue={
                                      values?.contactable_id
                                        ? values?.contactable_id
                                        : ""
                                    }
                                    setContactList={setContactList} // Update vendor list as new data loads
                                    setContactLoading={setContactLoading} // Control loading state
                                    onClear={() => {
                                      setFieldValue(`contactable_id`, "");
                                    }}
                                    className={
                                      errors?.contactable_id &&
                                      `focus-visible:ring-red-500 border-red-500`
                                    }
                                    loading={contactLoading}
                                  />
                                  {contactLoading && (
                                    <span className="absolute top-2 right-2 animate-spin">
                                      <Loader2 width={20} height={20} />
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}

                          <div className="grid gap-2">
                            <Label htmlFor="first_name">
                              <CustomLabelText
                                required={false}
                                labelText="First Name"
                                errorField={errors?.first_name}
                              />
                            </Label>
                            <Input
                              id="first_name"
                              type="text"
                              name="first_name"
                              value={
                                values?.first_name ? values?.first_name : ""
                              }
                              onChange={handleChange}
                              onBlur={handleBlur}
                              autoComplete="off"
                              onKeyPress={(e) => {
                                e.which === 13 && e.preventDefault();
                              }}
                              className={
                                errors?.first_name &&
                                `focus-visible:ring-red-500 border-red-500`
                              }
                            />
                          </div>
                          {/* </div> */}
                          {/* <div className="grid md:grid-cols-2 gap-4"> */}
                          <div className="grid gap-2">
                            <Label htmlFor="last_name">
                              <CustomLabelText
                                required={true}
                                labelText="Last Name"
                                errorField={errors?.last_name}
                              />
                            </Label>
                            <Input
                              id="last_name"
                              type="text"
                              name="last_name"
                              value={values?.last_name ? values?.last_name : ""}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              autoComplete="off"
                              onKeyPress={(e) => {
                                e.which === 13 && e.preventDefault();
                              }}
                              className={
                                errors?.last_name &&
                                `focus-visible:ring-red-500 border-red-500`
                              }
                            />
                          </div>

                          <div className="grid gap-2">
                            <Label htmlFor="business_name">
                              <CustomLabelText
                                required={false}
                                labelText="Business Name"
                                errorField={errors?.business_name}
                              />
                            </Label>
                            <Input
                              id="business_name"
                              type="text"
                              name="business_name"
                              value={
                                values?.business_name
                                  ? values?.business_name
                                  : ""
                              }
                              onChange={handleChange}
                              onBlur={handleBlur}
                              autoComplete="off"
                              onKeyPress={(e) => {
                                e.which === 13 && e.preventDefault();
                              }}
                              className={
                                errors?.business_name &&
                                `focus-visible:ring-red-500 border-red-500`
                              }
                            />
                          </div>
                          {/* </div> */}
                          {/* <div className="grid md:grid-cols-2 gap-4"> */}
                          <div className="grid gap-2">
                            <Label htmlFor="email">
                              <CustomLabelText
                                required={false}
                                labelText="Email"
                                errorField={errors?.email}
                              />
                            </Label>
                            <Input
                              id="email"
                              type="email"
                              placeholder="m@example.com"
                              required
                              autoComplete="off"
                              name="email"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values?.email}
                              className={
                                errors?.email &&
                                `focus-visible:ring-red-500 border-red-500`
                              }
                            />
                          </div>

                          <div className="grid gap-2">
                            <Label htmlFor="phone">
                              <CustomLabelText
                                required={false}
                                labelText="Phone"
                                errorField={errors?.phone}
                              />
                            </Label>
                            <PhoneInput
                              onChange={(e) => {
                                setFieldValue("phone", e);
                              }}
                              value={values?.phone}
                              defaultValue={"+61"}
                              defaultCountry={"AU"}
                              minLength={15}
                              maxLength={15}
                              onBlur={handleBlur}
                              className={
                                errors?.phone &&
                                `focus-visible:ring-red-500 border-red-500`
                              }
                            />
                          </div>
                          {/* </div> */}
                          {/* <div className="grid md:grid-cols-2 gap-4"> */}
                          <div className="grid gap-2">
                            <Label htmlFor="mobile">
                              <CustomLabelText
                                required={false}
                                labelText="Mobile No."
                                errorField={errors?.mobile}
                              />
                            </Label>
                            <PhoneInput
                              onChange={(e) => {
                                setFieldValue("mobile", e);
                              }}
                              value={values?.mobile}
                              defaultValue={"+61"}
                              defaultCountry={"AU"}
                              minLength={15}
                              maxLength={15}
                              onBlur={handleBlur}
                              className={
                                errors?.mobile &&
                                `focus-visible:ring-red-500 border-red-500`
                              }
                            />
                          </div>

                          <div className="grid gap-2">
                            <Label htmlFor="code">
                              <CustomLabelText
                                required={false}
                                labelText="Code"
                                errorField={errors?.code}
                              />
                            </Label>
                            <Input
                              id="code"
                              type="text"
                              name="code"
                              value={values?.code ? values?.code : ""}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              autoComplete="off"
                              onKeyPress={(e) => {
                                e.which === 13 && e.preventDefault();
                              }}
                              className={
                                errors?.code &&
                                `focus-visible:ring-red-500 border-red-500`
                              }
                            />
                          </div>

                          <div className="grid gap-2">
                            <Label htmlFor="percentage">
                              <CustomLabelText
                                required={false}
                                labelText="Percentage (%)"
                                errorField={errors?.percentage}
                              />
                            </Label>

                            <NumericFormat
                              type="text"
                              name={`percentage`}
                              value={values?.percentage}
                              onChange={handleChange}
                              onBlur={(e) => {
                                setFieldValue(`percentage`, e?.target?.value);
                              }}
                              decimalScale={2}
                              allowNegative={false}
                              thousandSeparator={true}
                              suffix="%"
                              isAllowed={(values) => MaxLimit(values)}
                              autoComplete="off"
                              onKeyPress={(e) => {
                                e.which === 13 && e.preventDefault();
                              }}
                              className={
                                errors?.percentage
                                  ? `${cn(
                                      "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                                    )} focus-visible:ring-red-500 border-red-500`
                                  : cn(
                                      "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                                    )
                              }
                            />
                          </div>

                          <div className="grid gap-2">
                            <div className="min-w-0">
                              <Label htmlFor="dob">
                                <CustomLabelText
                                  labelText="Date Of Birth"
                                  errorField={errors?.dob}
                                />
                              </Label>
                              <div className="relative mt-2">
                                <DateInputPicker
                                  date={values?.dob ? values?.dob : ""}
                                  onSelect={(e) => {
                                    setFieldValue("dob", e);
                                  }}
                                  handleDateInputChange={(e) => {
                                    setFieldValue("dob", e);
                                  }}
                                  inputClassName="w-full"
                                  className={""}
                                  disabledDate={{ after: new Date() }}
                                />
                              </div>
                            </div>
                          </div>
                          {/* </div> */}
                        </div>
                      </div>

                      <div className="grid gap-4 pt-4">
                        <CardTitle className="text-md">Address</CardTitle>
                        <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
                          <div className="grid md:grid-cols-2 gap-4">
                            <div className="grid gap-2">
                              <Label htmlFor="street">
                                <CustomLabelText
                                  required={false}
                                  labelText="Street Address"
                                  errorField={errors?.street}
                                />
                              </Label>
                              <Input
                                id="street"
                                placeholder="Enter Street"
                                required
                                name="street"
                                onChange={(e) => {
                                  setFieldValue("street", e?.target?.value);
                                  if (isChecked) {
                                    setFieldValue(
                                      "shipping_street",
                                      e?.target?.value,
                                    );
                                  }
                                }}
                                onBlur={handleBlur}
                                value={values?.street}
                                className={
                                  errors?.street &&
                                  `focus-visible:ring-red-500 border-red-500`
                                }
                              />
                            </div>
                            <div className="grid gap-2">
                              <Label htmlFor="state_id">
                                <CustomLabelText
                                  required={false}
                                  labelText="State"
                                  errorField={errors?.state_id}
                                />
                              </Label>
                              <div className="relative">
                                <SearchSelect
                                  frameworks={stateListing}
                                  optionType={"State"}
                                  clearable={true}
                                  onClear={() => {
                                    setFieldValue("state_id", "");
                                    setFieldValue("suburb_id", "");
                                    setSuburbList([]);

                                    if (isChecked) {
                                      setFieldValue("shipping_state_id", "");
                                      setFieldValue("shipping_suburb_id", "");
                                      setSuburbShippingList([]);
                                    }
                                  }}
                                  handleSelect={(e) => {
                                    setFieldValue("state_id", e);
                                    setFieldValue("suburb_id", "");
                                    setSuburbList([]);
                                    FetchSuburbList(e);
                                    if (isChecked) {
                                      setFieldValue("shipping_state_id", e);
                                      setFieldValue("shipping_suburb_id", "");
                                      setSuburbShippingList([]);
                                    }
                                  }}
                                  handleBlur={handleBlur}
                                  className={
                                    errors?.state_id &&
                                    `focus-visible:ring-red-500 border-red-500`
                                  }
                                  disabled={false}
                                  initialValue={values?.state_id}
                                />
                                {stateLoading && (
                                  <span className="absolute top-2 right-2 animate-spin">
                                    <Loader2 width={20} height={20} />
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="grid md:grid-cols-2 gap-4">
                            <div className="grid gap-2">
                              <div className="min-w-0">
                                <Label htmlFor="suburb_id">
                                  <CustomLabelText
                                    required={false}
                                    labelText="Suburb"
                                    errorField={errors?.suburb_id}
                                  />
                                </Label>
                                <div className="relative mt-2">
                                  <SuburbSelect
                                    state_id={values?.state_id}
                                    frameworkData={suburbListing}
                                    optionType={"Suburb"}
                                    loading={suburbLoading}
                                    clearable={true}
                                    onClear={() => {
                                      setFieldValue("suburb_id", "");
                                      if (isChecked) {
                                        setFieldValue("shipping_suburb_id", "");
                                      }
                                    }}
                                    handleSelect={(e) => {
                                      setFieldValue("suburb_id", e);
                                      if (isChecked) {
                                        setFieldValue("shipping_suburb_id", e);
                                      }
                                    }}
                                    handleBlur={handleBlur}
                                    className={
                                      errors?.suburb_id &&
                                      `focus-visible:ring-red-500 border-red-500`
                                    }
                                    disabled={values?.state_id ? false : true}
                                    initialValue={values?.suburb_id}
                                    // itemsPerPage={100}
                                    setSuburbList={setSuburbList} // Update suburb list as new data loads
                                    setSuburbLoading={setSuburbLoading}
                                  />
                                  {suburbLoading && (
                                    <span className="absolute top-2 right-2 animate-spin">
                                      <Loader2 width={20} height={20} />
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="grid gap-2">
                              <Label htmlFor="postal_code">
                                <CustomLabelText
                                  required={false}
                                  labelText="Postal Code"
                                  errorField={errors?.postal_code}
                                />
                              </Label>
                              <PostalCodeInput
                                id="postal_code"
                                placeholder="Enter Postal Code"
                                required={true}
                                name="postal_code"
                                handleChange={(e) => {
                                  setFieldValue("postal_code", e);
                                  if (isChecked) {
                                    setFieldValue("shipping_postal_code", e);
                                  }
                                }}
                                handleBlur={handleBlur}
                                className="justify-start"
                                inputClassName={
                                  errors?.postal_code &&
                                  `focus-visible:ring-red-500 border-red-500`
                                }
                                value={
                                  values?.postal_code ? values?.postal_code : ""
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr className="hr-content mt-4" />

                      <div className="flex items-center space-x-2 mt-4">
                        <Checkbox
                          id="terms"
                          checked={isChecked}
                          name="same_address"
                          onClick={() => toggleChecked(values, setFieldValue)}
                          disabled={
                            !values?.street ||
                            !values?.state_id ||
                            !values?.postal_code ||
                            !values?.suburb_id
                          }
                        />
                        <label
                          htmlFor="terms"
                          className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                        >
                          Same as Address
                        </label>
                      </div>
                      <div className="grid gap-4 pt-4">
                        <CardTitle className="text-md">
                          Street Address
                        </CardTitle>
                        <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
                          <div className="grid md:grid-cols-2 gap-4">
                            <div className="grid gap-2">
                              <Label htmlFor="shipping_street">
                                <CustomLabelText
                                  required={false}
                                  labelText="Street Address"
                                  errorField={errors?.shipping_street}
                                />
                              </Label>
                              <Input
                                id="shipping_street"
                                placeholder="Enter Street"
                                required
                                name="shipping_street"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values?.shipping_street}
                                disabled={isChecked}
                                className={
                                  errors?.shipping_street &&
                                  `focus-visible:ring-red-500 border-red-500`
                                }
                              />
                            </div>
                            <div className="grid gap-2">
                              <Label htmlFor="shipping_state_id">
                                <CustomLabelText
                                  required={false}
                                  labelText="State"
                                  errorField={errors?.shipping_state_id}
                                />
                              </Label>
                              <div className="relative">
                                <SearchSelect
                                  frameworks={stateListing}
                                  optionType={"State"}
                                  clearable={true}
                                  onClear={() => {
                                    setFieldValue("shipping_state_id", "");
                                    setFieldValue("shipping_suburb_id", "");
                                    setSuburbShippingList([]);
                                  }}
                                  handleSelect={(e) => {
                                    setFieldValue("shipping_state_id", e);
                                    FetchSuburbShippingList(e);
                                    setFieldValue("shipping_suburb_id", "");
                                    setSuburbShippingList([]);
                                  }}
                                  handleBlur={handleBlur}
                                  className={
                                    errors?.shipping_state_id &&
                                    `focus-visible:ring-red-500 border-red-500`
                                  }
                                  disabled={isChecked}
                                  initialValue={values?.shipping_state_id}
                                />
                                {stateLoading && (
                                  <span className="absolute top-2 right-2 animate-spin">
                                    <Loader2 width={20} height={20} />
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="grid md:grid-cols-2 gap-4">
                            <div className="grid gap-2">
                              <div className="min-w-0">
                                <Label htmlFor="shipping_suburb_id">
                                  <CustomLabelText
                                    required={false}
                                    labelText="Suburb"
                                    errorField={errors?.shipping_suburb_id}
                                  />
                                </Label>
                                <div className="relative mt-2">
                                  <SuburbSelect
                                    state_id={values?.shipping_state_id}
                                    frameworkData={suburbShippingListing}
                                    loading={suburbLoading}
                                    optionType={"Suburb"}
                                    clearable={true}
                                    onClear={() => {
                                      setFieldValue("shipping_suburb_id", "");
                                      if (isChecked) {
                                        setFieldValue("shipping_suburb_id", "");
                                      }
                                    }}
                                    handleSelect={(e) => {
                                      setFieldValue("shipping_suburb_id", e);
                                      if (isChecked) {
                                        setFieldValue("shipping_suburb_id", e);
                                      }
                                    }}
                                    handleBlur={handleBlur}
                                    className={
                                      errors?.shipping_suburb_id &&
                                      `focus-visible:ring-red-500 border-red-500`
                                    }
                                    disabled={
                                      isChecked ||
                                      (values?.shipping_state_id ? false : true)
                                    }
                                    initialValue={values?.shipping_suburb_id}
                                    // itemsPerPage={100}
                                    setSuburbList={setSuburbShippingList} // Update suburb list as new data loads
                                    setSuburbLoading={setSuburbShippingLoading}
                                  />
                                  {suburbShippingLoading && (
                                    <span className="absolute top-2 right-2 animate-spin">
                                      <Loader2 width={20} height={20} />
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="grid gap-2">
                              <Label htmlFor="shipping_postal_code">
                                <CustomLabelText
                                  required={false}
                                  labelText="Postal Code"
                                  errorField={errors?.shipping_postal_code}
                                />
                              </Label>
                              <PostalCodeInput
                                id="shipping_postal_code"
                                placeholder="Enter Postal Code"
                                required={true}
                                name="shipping_postal_code"
                                handleChange={(e) => {
                                  setFieldValue("shipping_postal_code", e);
                                }}
                                handleBlur={handleBlur}
                                className="justify-start"
                                disabled={isChecked}
                                inputClassName={
                                  errors?.shipping_postal_code &&
                                  `focus-visible:ring-red-500 border-red-500`
                                }
                                value={
                                  values?.shipping_postal_code
                                    ? values?.shipping_postal_code
                                    : ""
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="grid gap-4 pt-4">
                        <CardTitle className="text-md">
                          Bank Account Details
                        </CardTitle>
                        <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
                          <div className="grid md:grid-cols-2 gap-4">
                            <div className="grid gap-2">
                              <div className="min-w-0">
                                <Label htmlFor="bank_id">
                                  <CustomLabelText
                                    required={false}
                                    labelText="Bank Name"
                                    errorField={errors?.bank_id}
                                  />
                                </Label>
                                <div className="relative mt-2">
                                  <SearchSelect
                                    frameworks={bankListing}
                                    optionType={"Bank"}
                                    handleSelect={(e) => {
                                      setFieldValue("bank_id", e);
                                    }}
                                    handleBlur={handleBlur}
                                    className={
                                      errors?.bank_id &&
                                      `focus-visible:ring-red-500 border-red-500`
                                    }
                                    disabled={false}
                                    initialValue={values?.bank_id}
                                  />
                                  {bankLoading && (
                                    <span className="absolute top-2 right-2 animate-spin">
                                      <Loader2 width={20} height={20} />
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="grid gap-2">
                              <Label htmlFor="account_name">
                                <CustomLabelText
                                  required={false}
                                  labelText="Bank Account Name"
                                  errorField={errors?.account_name}
                                />
                              </Label>
                              <Input
                                type="text"
                                name="account_name"
                                value={
                                  values?.account_name
                                    ? values?.account_name
                                    : ""
                                }
                                onChange={handleChange}
                                onBlur={handleBlur}
                                autoComplete="off"
                                onKeyPress={(e) => {
                                  e.which === 13 && e.preventDefault();
                                }}
                                className={
                                  errors?.account_name &&
                                  `focus-visible:ring-red-500 border-red-500`
                                }
                              />
                            </div>
                          </div>
                          <div className="grid md:grid-cols-2 gap-4">
                            <div className="grid gap-2">
                              <Label htmlFor="bsb">
                                <CustomLabelText
                                  required={false}
                                  labelText="BSB"
                                  errorField={errors?.bsb}
                                />
                              </Label>
                              <ReactInputMask
                                id="bsb"
                                type="text"
                                name="bsb"
                                value={values?.bsb ? values?.bsb : ""}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                mask="999-999"
                                maskChar={null}
                                autoComplete="off"
                                onKeyPress={(e) => {
                                  e.which === 13 && e.preventDefault();
                                }}
                                className={
                                  errors?.bsb
                                    ? `${cn(
                                        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                                      )} focus-visible:ring-red-500 border-red-500`
                                    : cn(
                                        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                                      )
                                }
                              />
                            </div>
                            <div className="grid gap-2">
                              <Label htmlFor="account_number">
                                <CustomLabelText
                                  required={false}
                                  labelText="Account Number"
                                  errorField={errors?.account_number}
                                />
                              </Label>
                              <ReactInputMask
                                id="account_number"
                                type="text"
                                name="account_number"
                                value={
                                  values?.account_number
                                    ? values?.account_number
                                    : ""
                                }
                                onChange={handleChange}
                                onBlur={handleBlur}
                                mask="999999999"
                                maskChar={null}
                                autoComplete="off"
                                onKeyPress={(e) => {
                                  e.which === 13 && e.preventDefault();
                                }}
                                className={
                                  errors?.account_number
                                    ? `${cn(
                                        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                                      )} focus-visible:ring-red-500 border-red-500`
                                    : cn(
                                        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                                      )
                                }
                              />
                            </div>
                          </div>
                          <div className="grid md:grid-cols-2 gap-4 items-baseline">
                            <div className="grid gap-2">
                              <Label htmlFor="opening_balance">
                                <CustomLabelText
                                  required={false}
                                  labelText="Opening Balance($)"
                                  errorField={errors?.opening_balance}
                                />
                              </Label>

                              <NumericFormat
                                type="text"
                                name="opening_balance"
                                value={values?.opening_balance}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                decimalScale={2}
                                allowNegative={false}
                                thousandSeparator={true}
                                isAllowed={(values) => MaxLimit(values)}
                                autoComplete="off"
                                onKeyPress={(e) => {
                                  e.which === 13 && e.preventDefault();
                                }}
                                className={
                                  errors?.opening_balance
                                    ? `${cn(
                                        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                                      )} focus-visible:ring-red-500 border-red-500`
                                    : cn(
                                        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                                      )
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  </Step>
                )}

                {edit && amlCTFEnable && (
                  <Step
                    label="Risk Assessments"
                    horizontalStepClassName={"flex flex-col gap-2 font-bold"}
                  >
                    <AssessmentStep
                      mainData={beneficaryData}
                      values={values}
                      errors={errors}
                      setFieldValue={setFieldValue}
                      handleBlur={handleBlur}
                      edit={edit}
                      organizationData={organizationData}
                      sectionType={sectionType}
                      setSectionType={setSectionType}
                      validateField={validateField}
                      setTouched={setTouched}
                    />
                  </Step>
                )}

                {edit &&
                  amlCTFEnable &&
                  (values?.type == "1" ||
                    (values?.type == "2" && values?.entity_type == "1")) && (
                    <Step
                      label="Verifications"
                      horizontalStepClassName={"flex flex-col gap-2 font-bold"}
                    >
                      <VerificationStep
                        loading={loading}
                        mainData={beneficaryData}
                        values={values}
                        errors={errors}
                        handleBlur={handleBlur}
                        setFieldValue={setFieldValue}
                        handleChange={handleChange}
                        organizationData={organizationData}
                        edit={edit}
                        verificationMethods={verificationMethods}
                        verificationTypes={verificationTypes}
                        setLoading={setLoading}
                        fetchData={fetchData}
                      />
                    </Step>
                  )}
              </Stepper>
            </div>

            <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-end">
              <Button type="submit" disabled={!isValid}>
                {currentStep ===
                (values?.type == "2" && values?.entity_type != "1"
                  ? stepsData?.filter((item) => item?.label !== "Verifications")
                  : stepsData
                )?.length -
                  1
                  ? "Save"
                  : "Save & Next"}
              </Button>
              {/* {stepsData?.length - 1 !== currentStep && (
                              <Button
                                className="reset ml-3"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setCurrentStep(Number(Number(currentStep) + 1));
                                }}
                              >
                                Next
                              </Button>
                            )} */}
              {currentStep !== 0 && (
                <Button
                  className="reset ml-3"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={(e) => {
                    e.preventDefault();
                    setCurrentStep(Number(Number(currentStep) - 1));
                  }}
                  variant="secondary"
                >
                  Previous
                </Button>
              )}
              <Button
                className="reset ml-3"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  e.preventDefault();
                  toggleShowAddEditBeneficary();
                }}
                variant="secondary"
              >
                Cancel
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
};

export default AddEditBeneficary;
